import styles from './AppForm.module.scss';
import Switch from '@mui/material/Switch';
import UserNameTypeDropdown from './AppAuxForm/UserNameTypeDropdown';
import { Button } from '@upmc/ims.component-library';
//param @app : AppManagementModel
//param @setApp : function
const AppAuxForm = ({ app, setApp }) => {
	const REACT_APP_TYPES = {
		simple: 'Simple',
		empty: 'Empty',
	};

	const handleChange = e => {
		setApp({
			...app,
			appAux: {
				...app.appAux,
				[e.target.name]: e.target.value,
			},
		});
	};

	const handleBoolToggle = e => {
		setApp({
			...app,
			appAux: {
				...app.appAux,
				[e.target.name]: !app.appAux[e.target.name],
			},
		});
	};

	//resolve error messages cause by null or undefined values on inputs
	const resolveTextAreaNull = value => {
		if (value === null) {
			return '';
		} else return value;
	};

	const resolveBoolNull = value => {
		if (value === null || value === undefined) {
			return false;
		} else return value;
	};

	const handleReactAppTypeChange = e => {
		if (e.target.checked) {
			setApp({
				...app,
				appAux: {
					...app.appAux,
					reactAppType: REACT_APP_TYPES.empty,
				},
			});
		} else {
			setApp({
				...app,
				appAux: {
					...app.appAux,
					reactAppType: REACT_APP_TYPES.simple,
				},
			});
		}
	};

	return (
		<div className={styles.formContainer}>
			{/* rapFlag : bool */}
			<p>Enable multi-user request flow</p>
			<Switch
				checked={resolveBoolNull(app?.appAux?.rapFlag)}
				name='rapFlag'
				onClick={e => handleBoolToggle(e)}
			/>
			{/* pwdSynch_Flag*/}
			<p>Enable Terminating Network Dependent App Immediately</p>
			<Switch
				checked={resolveBoolNull(app?.appAux?.pwdSynch_Flag)}
				name='pwdSynch_Flag'
				onClick={e => handleBoolToggle(e)}
			/>
			{/*reactAppType : string (64)*/}
			<p>App has empty request form</p>
			<Switch
				checked={
					app.appAux?.reactAppType?.toLowerCase() ===
					REACT_APP_TYPES.empty.toLowerCase()
				}
				name='reactAppType'
				onClick={e => handleReactAppTypeChange(e)}
			/>
			{/* roleDescriptionLink : string(256) */}
			<div className={styles.detailLabel}>
				<p>
					Role Description Link{' '}
					<span className={styles.characterCount}>
						(
						{app?.appAux?.roleDescriptionLink?.length
							? app?.appAux?.roleDescriptionLink?.length
							: 0}
						/{256})
					</span>
				</p>
				<div>
					<input
						name='roleDescriptionLink'
						onChange={e => handleChange(e)}
						value={resolveTextAreaNull(
							app?.appAux?.roleDescriptionLink
						)}
						maxLength={256}
					/>
					<Button
						onClick={() => {
							setApp({
								...app,
								appAux: {
									...app.appAux,
									roleDescriptionLink:
										'/AppRoleDescriptions?appID=' +
										app.appMaster.id,
								},
							});
						}}
						sx={{ mx: '.5em' }}
					>
						Use CMS Page Link
					</Button>
				</div>
			</div>
			{/*userNameTypeID*/}
			<p>User Name Type</p>
			<UserNameTypeDropdown app={app} setApp={setApp} />
		</div>
	);
};

export default AppAuxForm;
